import Table from '../../../../atoms/display/Table'
import TableRow from '../../../../atoms/display/TableRow'
import TableCell from '../../../../atoms/display/TableCell'
import Button from '../../../../atoms/inputs/Button'
import { FlexColumn, FlexRow } from '../../../../atoms/layout/Flex'
import Label from '../../../../atoms/display/Label'
import { VisitorRegistrationFormSubcontractor } from '../../../../../types/Company'
import {
  useVisitorRegistrationFormSubcontractorDeleteDialog,
  useVisitorRegistrationFormSubcontractorEditDialog,
} from '../../../../../hooks/useDialog'

type Props = {
  subcontractors: VisitorRegistrationFormSubcontractor[]
}

export default function VisitorRegistrationSubcontractorTable(props: Props) {
  const { subcontractors } = props
  const editDialog = useVisitorRegistrationFormSubcontractorEditDialog()
  const deleteDialog = useVisitorRegistrationFormSubcontractorDeleteDialog()

  return (
    <Table
      header={
        <TableRow>
          <TableCell header size="xs" />
          <TableCell header size="sm2">
            事業者名
          </TableCell>
          <TableCell header size="xs">
            代表者氏名
          </TableCell>
          <TableCell header>住所</TableCell>
          <TableCell header size="sm2">
            電話番号
          </TableCell>
        </TableRow>
      }
    >
      {subcontractors.map((subcontractor) => (
        <TableRow key={subcontractor.id}>
          <TableCell size="xs" align="center">
            <FlexColumn>
              <Button size="sm" height="small" onClick={() => editDialog.open(subcontractor)}>
                編集
              </Button>
              <Button size="sm" height="small" color="caution" onClick={() => deleteDialog.open(subcontractor)}>
                削除
              </Button>
            </FlexColumn>
          </TableCell>
          <TableCell size="sm2">
            <FlexColumn space={0}>
              <Label text={subcontractor.kana} variant="caption" />
              <Label text={subcontractor.name} />
            </FlexColumn>
          </TableCell>
          <TableCell size="xs">
            <FlexColumn space={0}>
              <Label text={subcontractor.representativeKana} variant="caption" />
              <Label text={subcontractor.representativeName} />
            </FlexColumn>
          </TableCell>
          <TableCell>
            <FlexColumn space={0}>
              <FlexRow space={0}>
                <Label text="〒" variant="caption" />
                <Label text={subcontractor.zipCode} variant="caption" />
              </FlexRow>
              <Label text={subcontractor.address} variant="caption" />
            </FlexColumn>
          </TableCell>
          <TableCell size="sm2" align="center">
            <Label text={subcontractor.phoneNumber} />
          </TableCell>
        </TableRow>
      ))}
    </Table>
  )
}
